export default __webpack_public_path__ + "media/images/mailer/icon_cached-d1942397cbe1d7d4c3383afc2e4506a5.png";